// extracted by mini-css-extract-plugin
module.exports = {"vibration":"Login_vibration_xp7Vu"};